




































































































import {MealComponent} from '../types';
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import ComponentService from '../services/ComponentService';

@Component
export default class MealComponents extends Vue {

  private loading: boolean = false;
  private headers: object[] = [
    {sortable: false},
    {
      text: 'id',
      align: 'left',
      value: 'foodid'
    },
    { text: 'Description', value: 'fooddescription' },
    { text: 'Portion basis', value: 'measurename' },
    { text: 'Portion multiplier', value: 'portion_multiplier' }
  ];
  private snackbar: boolean = false;
  private snackbarText: string = '';
  private snackbarColor: string = '';


  private async mounted() {
    this.loading = true;
    try {
      await this.loadItems();
    } catch (e) {
      this.displaySnackbar(e.message, 'error');
    } finally {
      this.loading = false;
    }
  }

  private async loadItems() {
    const { data } = await ComponentService.getComponents();
    this.$store.dispatch('setComponents', data);
  }

  private displaySnackbar(msg: string, color: string) {
    this.snackbarText = msg;
    this.snackbarColor = color;
    this.snackbar = true;
  }

  private getFormattedDate(date: string) {
    let formatted = '';
    if (date) {
      formatted = moment(date).format('MMM Do YYYY, hh:mm');
    }
    return formatted;
  }

  private async addToMeal(item: {id: number, foods: Array<{component: number}>}) {
    try {
      this.loading = true;
      for (const food of item.foods) {
        food.component = item.id;
      }
      this.$store.dispatch('addIngredientsToMeal', item.foods);
      this.displaySnackbar('Component ingredients added to new meal', 'blue-grey');
    } catch (e) {
      this.displaySnackbar(e.message, 'error');
    } finally {
      this.loading = false;
    }
  }

  private async deleteComponent(id: number) {
    try {
      this.loading = true;
      const response = confirm(`Are you sure you want to delete this component?`)
      && await ComponentService.deleteComponent(id);
      if (response) {
        this.$store.dispatch('deleteComponent', id);
        this.displaySnackbar('Component deleted!', 'blue-grey');
      }
    } catch (e) {
      this.displaySnackbar(e.message, 'error');
    } finally {
      this.loading = false;
    }
  }

  private async updateFood(food: any, componentId: string) {
    try {
      this.loading = true;
      await ComponentService.updateComponentFood(componentId, food);

      const measure = food.measures.find(
        (item: {measureid: string}) => parseInt(item.measureid, 10) === parseInt(food.portion_basis, 10)
      );

      food.measurename = measure ? measure.measurename : `measure id ${food.portion_basis} is not valid, will default to 100g`;;
      this.$store.dispatch('updateComponentFood', {food, componentId});
      this.displaySnackbar('Component updated!', 'blue-grey');
    } catch (e) {
      this.displaySnackbar(e.message, 'error');
    } finally {
      this.loading = false;
    }
  }

  get componentItems() {
    return this.$store.getters.getMealComponents;
  }
}
